import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { getConversationQueryKey } from "modules/conversations/lib/conversationQuery"
import { getConversationsQueryKey } from "modules/conversations/lib/conversationsQuery"
import { CustomerResponseDataSchema, DataResponse, UpdateCustomerBodySchema } from "schema"
import { z } from "zod"
import { getCustomerQueryKey } from "../lib/customerQuery"
import { getCustomersQueryKey } from "../lib/customersQuery"
import { getTagsQueryKey } from "../lib/tagsQuery"

type Params = z.input<typeof UpdateCustomerBodySchema>

type Response = DataResponse<z.infer<typeof CustomerResponseDataSchema>>

type Props = {
  customerId: string
  conversationId?: string
}

export function useUpdateCustomerMutation(props: Props) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (params: Params) => {
      const response = await axios.put<Response>(`/customers/${props.customerId}`, {
        name: params.name,
        firstName: params.firstName,
        lastName: params.lastName,
        email: params.email,
        phone: params.phone,
        metadata: params.metadata,
        country: params.country,
        locale: params.locale,
        useChannel: params.useChannel,
        clientId: params.clientId,
        tags: params.tags,
      })

      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: getCustomerQueryKey(props.customerId),
      })
      props.conversationId &&
        queryClient.invalidateQueries({
          queryKey: getConversationQueryKey(props.conversationId),
        })
      queryClient.invalidateQueries({
        queryKey: getConversationsQueryKey(),
      })
      queryClient.invalidateQueries({
        queryKey: getCustomersQueryKey(),
      })
      queryClient.invalidateQueries({ queryKey: getTagsQueryKey() })
    },
  })
}
